<template>
  <div class="outer-container">
    <div class="container">
      <h5>Contacte-me</h5>
      <p>
        Envie a sua mensagem que eu responderei logo que possível.
      </p>
      <form @submit.prevent="sendEmail">
        <label for="email"
          >Email
          <input
            @focus="clearErrors"
            type="text"
            inputmode="email"
            autocomplete="current-email"
            v-model="email"
            name="new-email"
            id="email"
            required
          />
        </label>
        <label for="name"
          >Nome
          <input type="text" inputmode="text" autocomplete="name" required />
        </label>
        <label for="message-box"
          >Mensagem
          <textarea
            inputmode="text"
            rows="8"
            autocomplete="off"
            v-model="message"
            name="message-box"
            id="message-box"
            required
          />
        </label>
        <AppButton text="Enviar Mensagem" />
        <p @click="goBack" class="button" role="button">Voltar</p>
      </form>
    </div>
    <TheFooter />
  </div>
</template>

<script>
import axios from "axios";
import AppButton from "@/components/AppButton.vue";
import TheFooter from "@/components/TheFooter.vue";

export default {
  name: "SignIn",
  components: {
    AppButton,
    TheFooter
  },
  data() {
    return {
      email: "",
      message: ""
    };
  },
  methods: {
    sendEmail() {
      return 1;
    },
    clearErrors() {
      return 1;
    },
    goBack() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
footer {
  margin-top: auto;
}

button {
  margin: 0.8rem auto 1.6rem auto;
  background-color: var(--color-primary);
  color: var(--color-quaternary);
}

.button {
  text-align: center;
  color: var(--color-secondary);
  margin-bottom: 1.6rem;
}

label {
  color: var(--color-tertiary);
  margin: 0 0 1.6rem 0;
}

h5 {
  margin-bottom: 0.8rem;
}

p {
  color: var(--color-tertiary);
  margin-bottom: 0.8rem;
}

.outer-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
}

.container {
  display: flex;
  flex-direction: column;
}
</style>
